/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  //apiurl:"http://10.0.53.134:8095/api/"
  //apiurl: "http://13.233.29.114:8090/api/",
  //apiurl: "http://127.0.0.1:8095/api/"
  //latestUrl: "http://43.205.193.210:8090/api/"
  apiurl: 'https://api.meity.gov.in/admin/'
};  
